export enum DeliveryOccasionLocation {
  Sweden,
  Germany,
  Denmark,
  Estonia
}

export default DeliveryOccasionLocation;